import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getProjects } from '../../../services/projects.supabase'
import { normalizeProjects } from './project.model'

const initialState = {
  currentRequestId: undefined,
  error: null,
  fetchedAt: null,
  loading: false,
  projects: [],
  status: 'idle',
}

const hasCachedProjects = (state) =>
  state.status === 'fulfilled' && state.projects.length > 0

export const onGetProjectsAsync = createAsyncThunk(
  'project/getProjects',
  async () => {
    const { data } = await getProjects()
    return data
  },
  {
    condition: (_, { getState }) => {
      const state = getState().projects

      if (state.status === 'pending') {
        return false
      }

      if (hasCachedProjects(state)) {
        return false
      }

      return true
    },
  },
)

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    
    builder.addCase(onGetProjectsAsync.pending, (state) => {
      state.loading = true
      state.status = 'pending'
    })
    
    builder.addCase(onGetProjectsAsync.fulfilled, (state, action) => {
      state.loading = false
      state.status = 'fulfilled'
      state.error = null
      state.fetchedAt = Date.now()

      const projects = Array.isArray(action.payload) ? action.payload : []
      state.projects = normalizeProjects(projects)
    })
    
    builder.addCase(onGetProjectsAsync.rejected, (state, action) => {
      state.loading = false
      state.status = 'rejected'
      state.error = action.error
      state.currentRequestId = undefined
    })

  }
})

export default projectSlice.reducer
